// extracted by mini-css-extract-plugin
module.exports = {"paper":"videos_paper__2s1on","topic":"videos_topic__3wAUw","cardContainer":"videos_cardContainer__1_cME"};